/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screens_EyesInputs */

const en_onboarding_screens_eyes = /** @type {(inputs: Onboarding_Screens_EyesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strains my eyes`)
};

const es_onboarding_screens_eyes = /** @type {(inputs: Onboarding_Screens_EyesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me cansa la vista`)
};

/**
* | output |
* | --- |
* | "Strains my eyes" |
*
* @param {Onboarding_Screens_EyesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_screens_eyes = /** @type {((inputs?: Onboarding_Screens_EyesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screens_EyesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_screens_eyes(inputs)
	return en_onboarding_screens_eyes(inputs)
});